import React, { useEffect, useCallback, useState } from 'react';
import { parseISO, format } from 'date-fns';
import { toast } from 'react-toastify';
import fileDownload from 'js-file-download';
import { MdAdd, MdImportExport } from 'react-icons/md';
import { IoMdMail } from 'react-icons/io';
import { FormLabel, FormGroup } from '@material-ui/core';
import {
  FaFacebookSquare,
  FaInstagram,
  FaRobot,
  FaPenSquare,
  FaWindowMaximize,
  FaTimes,
  FaWeebly,
  FaRocketchat,
  FaWhatsapp
} from 'react-icons/fa';
import api from '~/services/api';
import isNumber from '~/util/isNumber';
import DebounceTextField from '../Atendimento/Table/DebounceTextField';
import { Container, Menus, Filtro, DS, Button, NewButton } from './styles';
// Importando componente
import Card from '~/components/Card';
import Load from '~/components/Load';
import Table from './Table';
import { useSelector } from 'react-redux';


export default function Leads() {
  const [dados, setDados] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [filtroProduto, setFiltroProduto] = useState('');
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [dateInit, setDateInit] = useState(null);
  const [dateFinish, setDateFinish] = useState(null);
  const [dataInicial, setDataInicial] = useState(null);
  const [dataFinal, setDataFinal] = useState(null);
  const [telefone, setTelefone] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(true);
  const [carregar, setCarregar] = useState(false);
  const [filtros, setFiltros] = useState([]);
  const [idDatasSelected, setIdDatasSelected] = useState([])
  const [users, setUsers] = useState([])
  const user = useSelector(state => state.user.profile)


  const getDados = useCallback(async () => {
    setCarregar(true);
    const responseDados = await api.get('/leads', {
      params: {
        page,
        perPage,
        nome: search.trim().includes('@') ? '' : search.trim(),
        status,
        dataInicial,
        dataFinal,
        produto: filtros.length > 0 ? filtros?.filter(item => item.column === 'produto')[0]?.filter : '',
        email: filtros.length > 0 ? filtros?.filter(item => item.column === 'e-mail')[0]?.filter : '',
        telefone: filtros.length > 0 ? filtros?.filter(item => item.column === 'telefone')[0]?.filter : '',
        usuario: filtros.length > 0 ? filtros?.filter(item => item.column === 'usuário e-mail')[0]?.filter : ''
      },
    });

    const data = responseDados.data.leads.data.map(i => {
      const date = parseISO(i.created_at);
      // Formatar numero
      if (i.telefone.length === 11) {
        const DD = i.telefone.substr(0, 2);
        const digitoNove = i.telefone.substr(2, 1);
        const primeiroBloco = i.telefone.substr(3, 4);
        const segundoBloco = i.telefone.substr(7, 4);
        const numeroFormatado = `(${DD}) ${digitoNove} ${primeiroBloco}-${segundoBloco}`;
        return {
          ...i,
          dataFormat: format(date, 'dd/MM/yyyy HH:mm:ss'),
          numeroFormatado,
        };
      }
      if (i.telefone.length === 10) {
        const DD = i.telefone.substr(0, 2);
        const primeiroBloco = i.telefone.substr(2, 4);
        const segundoBloco = i.telefone.substr(6, 4);
        const numeroFormatado = `(${DD}) ${primeiroBloco}-${segundoBloco}`;

        return {
          ...i,
          dataFormat: format(date, 'dd/MM/yyyy HH:mm:ss'),
          numeroFormatado,
        };
      }

      return {
        ...i,
        dataFormat: format(date, 'dd/MM/yyyy HH:mm:ss'),
        numeroFormatado: i.telefone,
      };
    });

    const usersData = responseDados.data.users.map(user => {
      return {
        value: user.id,
        label: user.email
      }
    })

    setDados(data);
    setUsers(usersData)
    setPage(responseDados.data.leads.page);
    setPerPage(responseDados.data.leads.perPage);
    setTotal(Number(responseDados.data.leads.total));
    setLoading(false);
    setCarregar(false);
  }, [
    dataFinal,
    dataInicial,
    email,
    filtroProduto,
    filtros,
    page,
    perPage,
    search,
    status,
    telefone,
  ]);

  const getProdutos = useCallback(async () => {
    const responseProduto = await api.get('/produto-select');
    const data = responseProduto.data.map(produto => {
      if (produto.time_id === user.time_id) {
        return `${produto.name}`;
      }
    }).filter(Boolean);

    setProdutos(data);
  }, []);

  async function handleUserTransfer(idDatas, user, textArea) {

    await api.post('/transferencia-lead', {
        leads: idDatas,
        user_id: user,
        motivo: textArea
    })
    getDados();
  }

  useEffect(() => {
    getDados();
    getProdutos();
  }, [getDados, getProdutos, filtros]);

  async function handlePagination(number) {
    setPage(number);
  }

  async function handlePerPage(number) {
    setPerPage(number);
  }

  function handleSearch(value) {
    setSearch(value);
    setPage(1);
  }

  async function handleExportCSV() {
    try {
      const response = await api.get('export-lead-csv', {
        params: {
          all: search,
          status,
          produto: filtroProduto,
          dataInicial,
          dataFinal,
          telefone,
          email,
        },
      });
      fileDownload(response.data, 'relatorio-leads.csv');
      toast.success('Download feito com sucesso');
    } catch (error) {
      toast.error('Erro ao tentar fazer download csv.');
    }
  }

  function handleFiltrar() {
    if (dateInit && dateFinish) {
      const dtI = format(dateInit, 'yyyy-MM-dd');
      const dtF = format(dateFinish, 'yyyy-MM-dd');

      setDataInicial(dtI);
      setDataFinal(dtF);
    } else {
      toast.error('Preencha os campos data inicial e data final');
    }
  }

  function handleReset() {
    setSearch('');
    setStatus('');
    setFiltroProduto('');
    setDataInicial(null);
    setDataFinal(null);
    setDateInit(null);
    setDateFinish(null);
    setTelefone('');
    setEmail('');
    setFiltros('')
  }

  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Nome',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'canal',
      label: 'Canal',
      options: {
        filter: false,
        sort: false,
        customBodyRender(value) {
          switch (value) {
            case 'fb':
              return (
                <FaFacebookSquare
                  color="#FFF"
                  size={20}
                  title="Origem: Facebook"
                />
              );
            case 'wp':
              return (
                <FaWhatsapp
                  color="#FFF"
                  size={20}
                  title="Origem: Whatsapp"
                />
              );
            case 'ig':
              return (
                <FaInstagram color="#FFF" size={20} title="Origem: Instagram" />
              );
            case 'bot':
              return <FaRobot color="#FFF" size={20} title="Origem: ChatBot" />;
            case 'cms':
              return <FaPenSquare color="#FFF" size={20} title="Origem: CMS" />;
            case 'lp':
              return (
                <FaWindowMaximize
                  color="#FFF"
                  size={20}
                  title="Origem: Land Page"
                />
              );
            case 'mailing':
              return (
                <IoMdMail color="#FFF" size={20} title="Origem: Mailing" />
              );
            case 'st':
              return <FaWeebly color="#FFF" size={20} title="Origem: Site" />;
            case 'ch':
              return (
                <FaRocketchat color="#FFF" size={20} title="Origem: Chat" />
              );
            default:
              return (
                <FaTimes color="#FFF" size={20} title="Origem: Sem canal" />
              );
          }
        },
      },
    },
    {
      name: 'email',
      label: 'E-mail',
      options: {
        sort: false,
        filter: true,
        filterType: 'textField',
        customFilterListOptions: { render: v => `E-mail:${v}` },
        filterList: [],
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <div>
              <FormLabel>E-mail</FormLabel>
              <FormGroup row>
                <DebounceTextField
                  filter={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  type="text"
                />
              </FormGroup>
            </div>
          ),
        },
      },
    },
    {
      name: 'numeroFormatado',
      label: 'Telefone',
      options: {
        sort: false,
        filter: true,
        filterType: 'textField',
        customFilterListOptions: { render: v => `${v}` },
        filterList: [],
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <div>
              <FormLabel>Telefone</FormLabel>
              <FormGroup row>
                <DebounceTextField
                  filter={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  type="number"
                />
              </FormGroup>
            </div>
          ),
        },
      },
    },
    {
      name: 'produto.name',
      label: 'Produto',
      options: {
        sort: false,
        filter: true,
        filterType: 'dropdown',
        customFilterListOptions: { render: v => `${v}` },
        filterOptions: {
          names: produtos,
        },
      },
    },
    {
      name: 'user.time.name',
      label: 'Time',
      options: {
        filter: false,
        sort: false,
        filterType: 'dropdown'
      },
    },
    {
      name: 'user.email',
      label: 'Usuário e-mail',
      options: {
        filter: true,
        sort: false,
        filterType: 'dropdown'
      },
    },
    {
      name: 'dataFormat',
      label: 'Data de entrada',
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Leads</h4>
      <Card size={100}>
        <Menus>
          <Filtro>
            <DS
              selected={dateInit}
              onChange={date => setDateInit(date)}
              locale="pt-BR"
              placeholderText="Data inicial"
              dateFormat="dd/MM/yyyy"
              showPopperArrow={false}
              withPortal
            />
            <DS
              selected={dateFinish}
              onChange={date => setDateFinish(date)}
              locale="pt-BR"
              minDate={dateInit}
              placeholderText="Data final"
              dateFormat="dd/MM/yyyy"
              showPopperArrow={false}
              withPortal
            />
            <Button type="button" onClick={handleFiltrar}>
              Filtrar
            </Button>
            <NewButton to="/create-lead">
              <MdAdd size={16} color="#FFF" />
              Novo
            </NewButton>
            <NewButton to="/import-lead">
              <MdImportExport size={16} color="#FFF" />
              Importar
            </NewButton>
          </Filtro>
        </Menus>
        {!loading && (
          <Table
            data={dados}
            page={page}
            perPage={perPage}
            columns={columns}
            total={total}
            pagination={number => handlePagination(number)}
            editPerPege={number => handlePerPage(number)}
            search={value => handleSearch(value)}
            loading={carregar}
            handleExportCSV={handleExportCSV}
            handleFilterSubmit={filters => setFiltros(filters)}
            handleUserTransfer={(idDatas, user, textArea) => handleUserTransfer(idDatas, user, textArea)}
            reset={handleReset}
            users={users}
            ed={() => { }}
          />
        )}
      </Card>
    </Container>
  );
}
